var scrollToTriggerClassName =  'js-scroll-to-area';
var scrollToAreaClassName =  'scroll-to-area';

scrollTo = (element) => {
	window.scroll({
		behavior: 'smooth',
		left: 0,
		top: element.offsetTop - 40
	});
	console
}

if (document.getElementsByClassName(scrollToTriggerClassName).length) {

	document.querySelector("." + scrollToTriggerClassName).addEventListener('click', () => {

		if (document.getElementsByClassName(scrollToAreaClassName).length) {
			scrollTo(document.querySelector("." + scrollToAreaClassName));
		} else {
			console.log("Area classname ." + scrollToAreaClassName + " does not exist.");
		}

	});
}
